import logo from '../images/logo-dark.png';
import { useState, useEffect } from "react";
import './UnsubscribeUser.scss';
import apiService from '../Services/apiService';
import {Button} from "@fluentui/react-northstar";
const UnsubscribeUser = (props) => {
    const [token, setToken] = useState(null);
    const [isUserUnsubscribe, setIsUserUnsubscribe] = useState(0);
    useEffect(() => {
        var token = props.location.search.split('&').find((el) => el.includes("token=")).split('=')[1];
        setToken(token);
        console.log(token);
    }, [props.location.search]);
    
    const updateUnsubscribedUser = () => {
      apiService.updateUnsubscribedUser(token).then(
             (response) => {
                 if (response !== undefined && response !== "") {
                    setIsUserUnsubscribe(1);
                 }
                 else
                 {
                    alert ("Something went wrong, please try again later.");  
                 }
             }
         );
    }
    
    return (
        <>
          <div className="dash-container">
        <div className="container-fluid px-0">
            <div className="row no-gutters min-vh-100">
                <div className="col-md-12">
                    <div className="fullDash h-100">
                        <div className="header-trk">
                            <div className="hdrTrk-logo">
                                { <a className="navbar-logo" href="#" title="Logo">
                                    <img src={logo} alt="Logo" />
                                </a> }
                            </div>
                        </div>
                         <div className="dash-trk">
                            <div className="innerlogin-msg">

                            {isUserUnsubscribe === 0 && <div className="notification-msg">
                                     <div className="notification-msg-i text-primary" style= {{opacity: .3}}>
                                        <svg width="90" height="90" fill="currentColor" className="bi bi-envelope-x" viewBox="0 0 16 16">
                                            <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"/>
                                            <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"/>
                                          </svg>
                                    </div>
                                    <div className="notification-msg-h"><h4>We are <span style ={{fontSize :'36px'}}>&#128577;</span> to see you go !</h4></div> 
                                    <div className="notification-msg-p">
                                        Unsubscribe from our insightful notifications ?
                                    </div>
                                      <div className="notification-msg-btn">
                                     <Button className = "btn btn-sm mx-2 btn-light border"
                                        style={{minWidth:"100px",marginRight: "10px"}}
                                        onClick={() => updateUnsubscribedUser()}
                                        iconOnly
                                        size="small"
                                        content="Yes"
                                        secondary
                                    />
                                    <Button className = "btn btn-sm mx-2 btn-primary"
                                        style={{minWidth:"100px"}}
                                        onClick={() =>  setIsUserUnsubscribe(2)}
                                        iconOnly
                                        size="small"
                                        content="No"
                                        secondary
                                    />
                                  </div> 
                                </div> }
                                {isUserUnsubscribe === 1 && <div className="notification-msg">
                                     <div className="notification-msg-i text-primary" style= {{opacity: .3}}>
                                        <svg width="90" height="90" fill="currentColor" className="bi bi-envelope-x" viewBox="0 0 16 16">
                                            <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"/>
                                            <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-4.854-1.354a.5.5 0 0 0 0 .708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708 0Z"/>
                                          </svg>
                                    </div>
                                    <div className="notification-msg-h"><h4>We are <span style ={{fontSize :'36px'}}>&#128577;</span> to see you go !</h4></div> 
                                    <div className="notification-msg-p">
                                        You have been successfully unsubscribed from scheduled mails of A365 and will no longer receive them.
                                    </div>
                                </div> }
                                {isUserUnsubscribe === 2 && <div className="notification-msg">
                                      <div className="notification-msg-p">
                                        Thanks for choosing to stay connected with us. You'll continue to receive our latest updates.
                                    </div>
                                </div> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
            
        </>
    );
};
export default UnsubscribeUser;

